// Z3950Document1 
import { Name1 } from '../../ui/ot';

const Z3950Document1 = ({

}) => {
    return <>
        <Name1
            propsCategoryName="z39.50資料"
            propsCategoryTitle="欄位"

            propsPrimaryColorName='blue'
            propsPrimaryColor="#1e40af"
            propsSecodaryColor="#2563eb"

            createApiRoute='/cataloging/z3950_document/_2'
            editPageFrontendRoute='/cataloging/z3950_document/_3'//前端路徑，新增完成後重整用

            mainApiRoute='/cataloging/backend/z3950_document/view'
            dbCoverIdName="z3950_document_id"
        />

    </>
}
export default Z3950Document1


